import store from "../store";
import { getDomain } from "./helpers";

export function reportClientError(details) {
  if (!details || !details.message) return;

  var url = details.url || "";
  if (url.indexOf("logClientError") !== -1) return;

  fetch(getDomain() + "/api/errorLogs/logClientError", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: store.state.authentication.token || "",
    },
    body: JSON.stringify({
      message: String(details.message).substring(0, 2000),
      url: url,
      method: details.method || "",
      statusCode: details.statusCode || "0",
      page: window.location.pathname,
    }),
  }).catch(function() {});
}
